export function isIE11() {
  if (typeof window === 'undefined') {
    return false;
  }
  return !!window.MSInputMethodContext && !!document.documentMode;
}
//# sourceMappingURL=isIE11.js.map